module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2019_student_winner-f544fd0f3f7f088d0f6ec569419b4ffc.jpg";